<script setup lang="ts">
import { Container } from '@/components/Container';

interface Props {
	title?: string;
}

withDefaults(defineProps<Props>(), {
	title: 'Explore outros bairros próximos'
});
</script>
<template>
	<Container class="bg-white py-8 md:py-[60px]">
		<div class="flex w-full flex-col gap-[36px]">
			<header class="flex w-full items-center">
				<h2
					class="font-matter-sq text-2xl font-normal leading-[150%] tracking-[-0.03rem] text-primary md:text-4xl md:tracking-[-0.045rem]"
				>
					{{ title }}
				</h2>
			</header>
			<div class="grid grid-cols-12 gap-6">
				<slot name="default"></slot>
			</div>
		</div>
	</Container>
</template>
